module.exports = __webpack_public_path__ + "static/circleshot-508f571c9d6b1feda361c18c83d9e410.png";